
export const API_HEADER = {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*'
}